import { useWsmFitmentQualifierCreateMutation, WsmFitmentValueKind } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import React from "react";
import { useIntl } from "react-intl";

import { addToWsmFitmentList } from "../cache";
import WsmFitmentNamedDetailsPage from "../components/WsmFitmentNamedDetailsPage";
import { useWsmFitmentQualifiers } from "../hooks/useWsmFitmentVocabulary";
import { qualifierMessages } from "../messages";
import { wsmFitmentQualifierListPath, wsmFitmentQualifierUrl } from "../urls";
import { getWriteState } from "../utils";

export const WsmFitmentQualifierCreateView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();

  // Mounted so the refetch below reaches it: refetch-by-name skips an unmounted query.
  useWsmFitmentQualifiers();

  const [createQualifier, createQualifierOpts] = useWsmFitmentQualifierCreateMutation({
    // Payload errors render on the form; a toast would say them twice.
    disableNestedErrorHandling: true,
    // The detail screen reads its row from the list: put it there before navigating.
    update: (cache, { data }) => {
      const qualifier = data?.wsmFitmentQualifierCreate?.qualifier;

      if (qualifier && !data?.wsmFitmentQualifierCreate?.errors.length) {
        addToWsmFitmentList(cache, "wsmFitmentQualifiers", qualifier);
      }
    },
    refetchQueries: ["WsmFitmentQualifiers"],
    awaitRefetchQueries: true,
    onCompleted: result => {
      const qualifier = result.wsmFitmentQualifierCreate?.qualifier;

      if (qualifier && !result.wsmFitmentQualifierCreate?.errors.length) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        navigate(wsmFitmentQualifierUrl(qualifier.id));
      }
    },
  });
  const payload = createQualifierOpts.data?.wsmFitmentQualifierCreate;

  return (
    <WsmFitmentNamedDetailsPage
      title={intl.formatMessage(qualifierMessages.create)}
      backHref={wsmFitmentQualifierListPath}
      withValueKind={false}
      initialData={{ name: "", displayLabel: "", valueKind: WsmFitmentValueKind.TEXT }}
      errors={payload?.errors ?? []}
      disabled={createQualifierOpts.loading}
      saveButtonBarState={getWriteState(createQualifierOpts, payload)}
      onSubmit={data =>
        createQualifier({
          variables: {
            input: { name: data.name.trim(), displayLabel: data.displayLabel.trim() },
          },
        })
      }
    />
  );
};

export default WsmFitmentQualifierCreateView;
